import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, useNavigate } from "react-router-dom";

import { login } from "../actions/auth";

const Login = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { isLoggedIn } = useSelector((state) => state.auth);
  const { message } = useSelector((state) => state.message);

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [errors, setErrors] = useState({});

  const validate = () => {
    const newErrors = {};

    if (!username.trim()) {
      newErrors.username = "Username is required";
    }

    if (!password.trim()) {
      newErrors.password = "Password is required";
    }

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const handleLogin = async (e) => {
    e.preventDefault();

    if (!validate()) return;

    setLoading(true);

    try {
      await dispatch(login(username, password));

      navigate("/dashboard");
    } catch (err) {
      setLoading(false);
    }
  };

  if (isLoggedIn) {
    return <Navigate to="/dashboard" />;
  }

  return (
    <div
      style={{
        minHeight: "100vh",
        backgroundImage: `
          linear-gradient(
            rgba(219, 228, 238, 0.78),
            rgba(219, 228, 238, 0.78)
          ),
          url("https://images.unsplash.com/photo-1448375240586-882707db888b?q=80&w=1974&auto=format&fit=crop")
        `,
        backgroundSize: "cover",
        backgroundPosition: "center",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: 20,
        fontFamily: "Arial, sans-serif",
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: 430,
          background: "rgba(248,250,252,0.92)",
          backdropFilter: "blur(6px)",
          borderRadius: 22,
          padding: 40,
          boxShadow: "0 15px 40px rgba(15,23,42,0.18)",
          border: "1px solid rgba(255,255,255,0.7)",
        }}
      >
        {/* HEADER */}
        <div style={{ textAlign: "center", marginBottom: 35 }}>
          <img
            src="/assets/images/logo.jpg"
            alt="Logo"
            style={{
              width: 120,
              height: 120,
              objectFit: "cover",
              borderRadius: 18,
              display: "block",
              margin: "0 auto 18px auto",
              boxShadow: "0 10px 25px rgba(0,0,0,0.15)",
            }}
          />

          <h1
            style={{
              margin: 0,
              fontSize: 28,
              color: "#1e293b",
              fontWeight: 700,
            }}
          >
            GPS Dogs Tracking
          </h1>

          <p
            style={{
              marginTop: 10,
              color: "#64748b",
              fontSize: 15,
            }}
          >
            Platforma za praćenje lovačkih pasa
          </p>
        </div>

        {/* FORM */}
        <form onSubmit={handleLogin}>
          {/* USERNAME */}
          <div style={{ marginBottom: 22 }}>
            <label
              style={{
                display: "block",
                width: "80%",
                margin: "0 auto 8px auto",
                color: "#334155",
                fontWeight: 600,
                fontSize: 14,
              }}
            >
              Username
            </label>

            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Enter username"
              style={{
                width: "80%",
                margin: "0 auto",
                display: "block",
                padding: 14,
                borderRadius: 14,
                border: errors.username
                  ? "1px solid #ef4444"
                  : "1px solid #cbd5e1",
                background: "#ffffff",
                color: "#1e293b",
                fontSize: 15,
                outline: "none",
                boxSizing: "border-box",
              }}
            />

            {errors.username && (
              <div
                style={{
                  marginTop: 6,
                  color: "#ef4444",
                  fontSize: 13,
                }}
              >
                {errors.username}
              </div>
            )}
          </div>

          {/* PASSWORD */}
          <div style={{ marginBottom: 28 }}>
            <label
              style={{
                display: "block",
                width: "80%",
                margin: "0 auto 8px auto",
                color: "#334155",
                fontWeight: 600,
                fontSize: 14,
              }}
            >
              Password
            </label>

            <div
              style={{
                position: "relative",
                width: "80%",
                margin: "0 auto",
              }}
            >
              <input
                type={showPassword ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter password"
                style={{
                  width: "100%",
                  padding: 14,
                  paddingRight: 70,
                  borderRadius: 14,
                  border: errors.password
                    ? "1px solid #ef4444"
                    : "1px solid #cbd5e1",
                  background: "#ffffff",
                  color: "#1e293b",
                  fontSize: 15,
                  outline: "none",
                  boxSizing: "border-box",
                }}
              />

              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                style={{
                  position: "absolute",
                  right: 14,
                  top: "50%",
                  transform: "translateY(-50%)",
                  border: "none",
                  background: "transparent",
                  cursor: "pointer",
                  color: "#475569",
                  fontWeight: 600,
                  fontSize: 13,
                }}
              >
                {showPassword ? "Hide" : "Show"}
              </button>
            </div>

            {errors.password && (
              <div
                style={{
                  marginTop: 6,
                  color: "#ef4444",
                  fontSize: 13,
                }}
              >
                {errors.password}
              </div>
            )}
          </div>

          {/* BUTTON */}
          <button
            type="submit"
            disabled={loading}
            style={{
              width: "50%",
              display: "block",
              margin: "0 auto",
              padding: 15,
              borderRadius: 14,
              border: "none",
              background:
                "linear-gradient(135deg, #355e3b 0%, #24452a 100%)",
              color: "white",
              fontSize: 15,
              fontWeight: 700,
              cursor: "pointer",
              opacity: loading ? 0.7 : 1,
              boxShadow: "0 10px 20px rgba(36,69,42,0.2)",
            }}
          >
            {loading ? "Signing in..." : "Sign In"}
          </button>

          {/* ERROR */}
          {message && (
            <div
              style={{
                marginTop: 20,
                padding: 14,
                borderRadius: 12,
                background: "#fef2f2",
                border: "1px solid #fecaca",
                color: "#dc2626",
                textAlign: "center",
                fontSize: 14,
              }}
            >
              {message}
            </div>
          )}
        </form>
      </div>
    </div>
  );
};

export default Login;